module.exports = __webpack_public_path__ + "assets/dfbaff57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sport2.jpg
// module id = 109
// module chunks = 0